import { useContext, useMemo } from 'react';
import { PropertyContext } from './PropertyContext';
import { useObjectId } from '../../hooks/useObjectId';
import { HighlySensitivePropertyContext } from '../../../dataSensitivity/HighlySensitivePropertyContext';
import { overlayDecryptedValue } from '../../utils/overlayDecryptedValue';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyContextProvider = props => {
  const {
    accessLevelOverride,
    objectTypeId,
    property,
    value,
    preferDecryptedValue = false,
    timestamp
  } = props;
  const highlySensitivePropertyContext = useContext(HighlySensitivePropertyContext);
  const objectId = useObjectId();
  const propertyContextValue = useMemo(() => {
    const internalValue = preferDecryptedValue && highlySensitivePropertyContext ? overlayDecryptedValue({
      value,
      getHighlySensitivePropertyValue: highlySensitivePropertyContext.getHighlySensitivePropertyValue,
      objectId,
      objectTypeId,
      propertyName: property.name,
      timestamp
    }) : value;
    return {
      accessLevelOverride,
      objectTypeId,
      property,
      timestamp,
      value: internalValue
    };
  }, [preferDecryptedValue, highlySensitivePropertyContext, value, objectId, objectTypeId, property, timestamp, accessLevelOverride]);
  return /*#__PURE__*/_jsx(PropertyContext.Provider, {
    value: propertyContextValue,
    children: props.children
  });
};